// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"172":"invoices","535":"login","764":"payment","851":"expense"}[chunkId] + "." + {"172":"eea2f14b","535":"ee67f702","764":"4b03a404","851":"640a6c0a"}[chunkId] + ".css";
};